module.exports = __webpack_public_path__ + "static/media/close-white.c930b5bd.svg";